import React from 'react'
import { ErrorBoundary, ErrorBoundaryProps } from 'react-error-boundary'
import { useLogger } from './LoggerContext'

type Props = Pick<ErrorBoundaryProps, 'onError' | 'fallback' | 'children'>

export const ErrorBoundaryWithLogger: React.FC<Props> = ({ onError, children, fallback }) => {
  const logger = useLogger()

  return (
    <ErrorBoundary
      onError={(error, info) => {
        logger.logError(error)
        if (onError) onError(error, info)
      }}
      fallback={fallback}
    >
      {children}
    </ErrorBoundary>
  )
}
